import { render, staticRenderFns } from "./codeStore.vue?vue&type=template&id=2388be97&scoped=true"
import script from "./codeStore.vue?vue&type=script&lang=js"
export * from "./codeStore.vue?vue&type=script&lang=js"
import style0 from "./codeStore.vue?vue&type=style&index=0&id=2388be97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2388be97",
  null
  
)

export default component.exports